module.exports = __webpack_public_path__ + "static/media/pause.31898951.png";